import { useState } from "react";
import { Button } from "./ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "./ui/command";
import { CaretDown, Check, X } from "@phosphor-icons/react";

/**
 * Dropdown proyek dengan pencarian otomatis — ketik kode ATAU nama proyek, daftar terfilter.
 * allowClear=true menampilkan opsi "— Tanpa Proyek —" untuk melepas tautan.
 */
export function ProjectCombobox({ projects, value, onChange, placeholder = "Ketik kode/nama proyek…", testid = "project-combobox", allowClear = true }) {
  const [open, setOpen] = useState(false);
  const selected = projects.find((p) => p.id === value);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button type="button" variant="outline" role="combobox" aria-expanded={open} data-testid={testid} className="w-full justify-between font-normal">
          <span className="truncate">
            {selected ? (<><span className="font-mono-plex text-xs mr-1.5 text-slate-500">{selected.code}</span>{selected.name}</>) : placeholder}
          </span>
          <CaretDown size={14} className="ml-2 shrink-0 opacity-50" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-[--radix-popover-trigger-width] p-0" align="start">
        <Command>
          <CommandInput placeholder="Cari kode atau nama proyek…" data-testid={`${testid}-search`} />
          <CommandList>
            <CommandEmpty>Proyek tidak ditemukan.</CommandEmpty>
            <CommandGroup>
              {allowClear && (
                <CommandItem value="__none" onSelect={() => { onChange(null); setOpen(false); }} data-testid={`${testid}-opt-none`}>
                  <X size={14} className="mr-2 shrink-0 text-slate-400" />
                  <span className="text-slate-500">— Tanpa Proyek —</span>
                </CommandItem>
              )}
              {projects.map((p) => (
                <CommandItem key={p.id} value={`${p.code} ${p.name}`} onSelect={() => { onChange(p); setOpen(false); }} data-testid={`${testid}-opt-${p.id}`}>
                  <Check size={14} className={`mr-2 shrink-0 ${p.id === value ? "opacity-100" : "opacity-0"}`} />
                  <span className="font-mono-plex text-xs mr-1.5 text-slate-500 shrink-0">{p.code}</span>
                  <span className="truncate">{p.name}{p.customer_name ? <span className="text-xs text-slate-400"> · {p.customer_name}</span> : null}</span>
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}

export default ProjectCombobox;
